export default function EntryScreen({ onStart }: { onStart: () => void }) {
  const perks = [
    { icon: 'ri-user-received-line', label: 'Ücretsiz kayıt' },
    { icon: 'ri-eye-off-line', label: 'Maskeli profil' },
    { icon: 'ri-moon-line', label: 'Sessiz Kariyer modu' },
    { icon: 'ri-shield-check-line', label: 'Kontrollü iletişim' },
    { icon: 'ri-lock-unlock-line', label: 'Çift taraflı bilgi paylaşımı' },
  ];

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10">
        <div className="w-14 h-14 rounded-xl bg-dark-teal-50 flex items-center justify-center mx-auto mb-6">
          <i className="ri-user-add-line text-dark-teal-500 text-2xl" />
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 text-center mb-3">
          Terapist olarak güvenli şekilde katılın
        </h1>
        <p className="text-sm text-gray-500 text-center leading-relaxed mb-8 max-w-sm mx-auto">
          SpaProBridge'de profilinizi oluşturun, gizliliğinizi koruyarak uygun spa ve wellness işletmeleriyle eşleşin.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
          {perks.map((p) => (
            <div
              key={p.label}
              className="flex flex-col items-center gap-2 p-3 rounded-xl bg-off-white border border-gray-50 text-center"
            >
              <i className={`${p.icon} text-dark-teal-500 text-lg`} />
              <span className="text-xs font-medium text-deep-navy-400">{p.label}</span>
            </div>
          ))}
        </div>

        <button
          onClick={onStart}
          className="w-full py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
        >
          Kayıt İşlemine Başla
        </button>
        <p className="text-xs text-gray-400 text-center mt-4">
          Kayıt ücretsizdir. Telefon doğrulaması zorunludur.
        </p>
      </div>
    </div>
  );
}